/**
 * Templates Resource (placeholder for RJSF forms)
 */

import { List, Empty } from 'react-admin';

export const TemplateList = () => (
  <List>
    <Empty />
  </List>
);
